/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";
import CEO from "pages/LandingPages/CEO";

function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={12}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="info"
                    title="About Elections Nova Scotia"
                    description={
                      <>
                        Elections Nova Scotia is an independent, non-partisan agency that is responsible for the administration of the <a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><i><b><u>Elections Act</u></b></i></a>. Its mandate is to conduct provincial general elections and by-elections; ensure compliance with provincial electoral law including the political financing regime; establish and maintain election-related information including the Nova Scotia Register of Electors; seek advice and conduct studies related to electoral processes; and, conduct electoral education processes.
                        <br />
                        <br />
                        Elections Nova Scotia is also mandated to provide support to the independent boundaries commission charged with reviewing the boundaries of provincial electoral districts.
                        <br />
                        <br />
                        <a href="/files/ENS_OrgChart_English.pdf"><i><b><u>Elections Nova Scotia Organization Chart (English)</u></b></i></a>
                        <br />
                        <a href="/files/ENS_OrgChart_French.pdf"><i><b><u>Elections Nova Scotia Organization Chart (French)</u></b></i></a>
                      </>
                    }
                  />
                </MKBox>
              </Grid>
              {/* <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="payments"
                    title="Payments functionality"
                    description="We get insulted by others, lose trust for those We get back freezes"
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="apps"
                    title="Prebuilt components"
                    description="We get insulted by others, lose trust for those We get back freezes"
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="3p"
                    title="Improved platform"
                    description="We get insulted by others, lose trust for those We get back freezes"
                  />
                </MKBox>
              </Grid> */}
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image="/img/DorothyRice_CEO_Nov2022.jpg"
              title="Chief Electoral Officer of Nova Scotia"
              description="On November 8, 2022, the House of Assembly approved the appointment of Dorothy Rice as the Chief Electoral Officer for the Province of Nova Scotia for a term of 10 years."
              action={{
                type: "internal",
                route: "/ceo",
                component: <CEO/>,
                color: "info",
                label: "find out more",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
